// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2VqwP","left":"StickyBox_left__1c9A4","right":"StickyBox_right__36i_X"};